import { PageHero } from "@/components/site/PageHero";
import { Todo } from "@/components/site/Placeholders";
import { openCookiePreferences } from "@/components/site/CookieBanner";
import { COMPANY, PEC } from "@/data/site";

const Holder = () => (
  <strong>{COMPANY.name}, con sede legale in {COMPANY.legal}, P.IVA {COMPANY.vat}</strong>
);

const Draft = () => (
  <p className="!mt-0 rounded-xl border border-dashed border-rosso/50 bg-rosso/5 p-4 text-sm !text-rosso" data-testid="legal-draft-notice">
    Bozza standard da completare con i dati societari e da far verificare da un consulente prima della pubblicazione.
  </p>
);

const Wrap = ({ children, testId }) => (
  <section className="bg-white py-16 md:py-24" data-testid={testId}>
    <div className="legal mx-auto max-w-3xl px-5 sm:px-8">
      <Draft />
      {children}
    </div>
  </section>
);

export const PrivacyPolicy = () => (
  <div>
    <PageHero eyebrow="Informativa" lines={["Privacy Policy"]} intro="Informativa sul trattamento dei dati personali ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679 (GDPR)." />
    <Wrap testId="privacy-page">
      <h2>1. Titolare del trattamento</h2>
      <p>Il titolare del trattamento è <Holder />, contattabile all'indirizzo PEC <a href={`mailto:${PEC}`} className="font-semibold text-navy underline">{PEC}</a>.</p>
      <p>Responsabile della protezione dei dati (se nominato): <Todo>nome e recapiti del DPO</Todo>.</p>

      <h2>2. Dati trattati</h2>
      <ul>
        <li>Dati forniti volontariamente tramite il modulo di contatto: nome e cognome, telefono, email, tipologia di richiesta e contenuto del messaggio.</li>
        <li>Dati di navigazione raccolti dai sistemi informatici necessari al funzionamento del sito.</li>
      </ul>
      <p>Ti invitiamo a non inserire nel messaggio dati relativi alla salute se non strettamente necessari alla gestione della richiesta.</p>

      <h2>3. Finalità e base giuridica</h2>
      <ul>
        <li>Rispondere alle richieste inviate tramite il sito e organizzare i servizi richiesti (esecuzione di misure precontrattuali o contrattuali, art. 6.1.b GDPR).</li>
        <li>Valutare le candidature di potenziali partner (art. 6.1.b GDPR).</li>
        <li>Adempiere a obblighi di legge (art. 6.1.c GDPR).</li>
      </ul>

      <h2>4. Modalità e conservazione</h2>
      <p>I dati sono trattati con strumenti elettronici, con misure di sicurezza adeguate, e conservati per il tempo necessario a gestire la richiesta e comunque non oltre <Todo>periodo di conservazione</Todo>.</p>

      <h2>5. Destinatari</h2>
      <p>I dati possono essere comunicati ai partner operativi incaricati di svolgere il servizio richiesto e ai fornitori di servizi tecnici (hosting, invio email), nominati responsabili del trattamento. <Todo>Elenco o categorie dei responsabili</Todo>.</p>

      <h2>6. Diritti dell'interessato</h2>
      <p>Puoi esercitare i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione (artt. 15-22 GDPR) scrivendo all'indirizzo PEC <a href={`mailto:${PEC}`} className="font-semibold text-navy underline">{PEC}</a>. Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali.</p>

      <h2>7. Aggiornamenti</h2>
      <p>Ultimo aggiornamento: <Todo>data</Todo>.</p>
    </Wrap>
  </div>
);

export const CookiePolicy = () => (
  <div>
    <PageHero eyebrow="Informativa" lines={["Cookie Policy"]} intro="Informazioni sui cookie e sulle tecnologie simili utilizzate da questo sito." />
    <Wrap testId="cookie-page">
      <h2>1. Cosa sono i cookie</h2>
      <p>I cookie sono piccoli file di testo che i siti salvano sul dispositivo dell'utente. Tecnologie simili, come la memoria locale del browser, svolgono funzioni analoghe.</p>

      <h2>2. Cookie tecnici</h2>
      <p>Il sito utilizza strumenti tecnici necessari al suo funzionamento, tra cui la memorizzazione della scelta espressa nell'avviso cookie. Per questi strumenti non è richiesto il consenso.</p>

      <h2>3. Cookie analitici e di terze parti</h2>
      <p>Eventuali cookie analitici, di profilazione o di terze parti vengono attivati solo dopo il consenso espresso tramite l'avviso cookie. <Todo>Elenco degli eventuali strumenti di terze parti utilizzati</Todo>.</p>

      <h2>4. Gestione delle preferenze</h2>
      <p>Puoi modificare in qualsiasi momento la tua scelta.</p>
      <p>
        <button type="button" onClick={openCookiePreferences} data-testid="cookie-page-preferences-btn" className="rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-navy-deep">
          Modifica preferenze cookie
        </button>
      </p>

      <h2>5. Titolare del trattamento</h2>
      <p><Holder /> · PEC {PEC}. Per maggiori informazioni consulta la Privacy Policy.</p>
      <p>Ultimo aggiornamento: <Todo>data</Todo>.</p>
    </Wrap>
  </div>
);
